// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"ad4a867a","453":"c5a0ecf0"}[chunkId] + ".chunk.js";
};